var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M350.355,196.251h5.36a.706.706,0,0,0,0-1.412h-5.35l1.9-1.9a.706.706,0,0,0-1-1l-3.092,3.092a.7.7,0,0,0-.222.51v0a.707.707,0,0,0,.207.5l3.108,3.109a.706.706,0,0,0,1-1Z",
    transform: "translate(-347.949 -189.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M361.009,188.632h-2.353a.706.706,0,0,0,0,1.412h2.353a.472.472,0,0,1,.471.471v8.235a.471.471,0,0,1-.471.471h-2.353a.706.706,0,0,0,0,1.412h2.353a1.884,1.884,0,0,0,1.883-1.883v-8.235A1.885,1.885,0,0,0,361.009,188.632Z",
    transform: "translate(-350.891 -188.632)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.816abe97.svg";
export { ForwardRef as ReactComponent };